import React, { Component } from 'react';

/** Icone de menu para a secao Integracao (plug/link). */
export default class Integracao extends Component {
  render() {
    return (
      <svg viewBox="0 0 124 124" className="nano">
        <path
          className="white"
          d="M78.5,45.5l-8.2-8.2c-3.1-3.1-8.2-3.1-11.3,0L46.5,49.8c-3.1,3.1-3.1,8.2,0,11.3l2.1,2.1l8.5-8.5
          c1.2-1.2,3.1-1.2,4.2,0c1.2,1.2,1.2,3.1,0,4.2l-8.5,8.5l2.1,2.1c3.1,3.1,8.2,3.1,11.3,0l12.5-12.5c3.1-3.1,3.1-8.2,0-11.3
          L78.5,45.5z M45.5,78.5l8.2,8.2c3.1,3.1,8.2,3.1,11.3,0l12.5-12.5c3.1-3.1,3.1-8.2,0-11.3l-2.1-2.1l-8.5,8.5
          c-1.2,1.2-3.1,1.2-4.2,0c-1.2-1.2-1.2-3.1,0-4.2l8.5-8.5l-2.1-2.1c-3.1-3.1-8.2-3.1-11.3,0L45.5,67.2C42.4,70.3,42.4,75.4,45.5,78.5z
           M98.1,25.9C88.2,16,74.9,10.5,61,10.5S33.8,16,23.9,25.9C14,35.8,8.5,49.1,8.5,63s5.5,27.2,15.4,37.1C33.8,110,47.1,115.5,61,115.5
          s27.2-5.5,37.1-15.4C108,90.2,113.5,76.9,113.5,63S108,35.8,98.1,25.9z M91.4,94.4C83.5,102.3,72.6,106.6,61,106.6
          s-22.5-4.3-30.4-12.2C22.7,86.5,18.4,75.6,18.4,63s4.3-22.5,12.2-30.4C38.5,24.7,49.4,20.4,61,20.4s22.5,4.3,30.4,12.2
          C99.3,40.5,103.6,51.4,103.6,63S99.3,86.5,91.4,94.4z"
        />
      </svg>
    );
  }
}
